import { Laterality } from 'utils/enums'
import toBool from 'utils/toBool'
import { z } from 'zod'
import { GenericManagerSchema } from '../GenericManagerTask/GenericManagerSchema'

const MedicalActsClinicalApprovalFields = z.object({
	medicalActs: z.array(
		z
			.object({
				checked: z.boolean(),
				value: z
					.union([z.string(), z.number()])
					.transform((elem) => parseInt(elem, 10))
					.refine((elem) => elem >= 0, {
						message: 'must be a positive value',
						path: ['medicalActs', 'value'],
					}),
				id: z.number(),
				disabled: z.boolean().optional(),
				laterality: z.enum([
					Laterality.Left,
					Laterality.Right,
					Laterality.NotApplicable,
				]),
			})
			.strict()
	),
	needEscort: z.boolean().optional().transform(toBool),
	medicalObservation: z.string().optional(),
})

// Extended for non-admin path: TaskForwardingController sets these fields via
// setValue for type 4/2 requisitions, so the strict schema must accept them.
const MedicalActsClinicalApprovalFieldsForNonAdmin =
	MedicalActsClinicalApprovalFields.extend({
		outsideNetwork: z.boolean().optional(),
		providerId: z.union([z.string(), z.number()]).nullable().optional(),
	})

export const schema = (args) => {
	return MedicalActsClinicalApprovalFields.refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

export const strictSchema = (args) => {
	return MedicalActsClinicalApprovalFieldsForNonAdmin.strict().refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

export const ApproveMedicalActsClinicalSchema = (args) => schema(args)

export const MedicalActsClinicalApprovalSchema = (args) => strictSchema(args)

export const ExtendedMedicalActsClinicalApprovalSchema = (args) =>
	z.intersection(GenericManagerSchema(args), schema(args))
